import { FC } from 'react'
import { isEmpty } from 'lodash'

import { Tag } from 'Api'
import { Address } from 'components/UI'

const ShiftTags: FC<{ tags: Tag[] }> = ({ tags }) => {
  if (!tags || isEmpty(tags)) return null

  const regionalTags = tags.filter(tag => tag.type === 'regional')
  const locationTags = tags.filter(tag => tag.type === 'locations')
  const customTags = tags.filter(tag => tag.type === 'custom')
  const clientTags = tags.filter(tag => tag.type === 'clients')
  const resourceTags = tags.filter(tag => tag.type === 'resources')

  return (
    <div className="d-flex flex-column">
      {regionalTags.map((regionalTag: Tag) => (
        <span className="mb-2" key={regionalTag._id} id={`tag_${regionalTag._id}`}>
          <i className={`${regionalTag.icon} mr-2`} style={{ color: regionalTag.color }} />
          {regionalTag.name}
        </span>
      ))}

      {locationTags.map((locationTag: Tag) => (
        <span className="mb-2" key={locationTag._id} id={`tag_${locationTag._id}`}>
          <i className={`${locationTag.icon} mr-2`} style={{ color: locationTag.color }} />
          {locationTag.name}
          {!isEmpty(locationTag.address) ? (
            <small className="d-block">
              <u>
                <Address address={locationTag.address} minimum withLink icon className="font-italic" />
              </u>
            </small>
          ) : null}
        </span>
      ))}

      {clientTags.map((clientTag: Tag) => (
        <span className="mb-2" key={clientTag._id} id={`tag_${clientTag._id}`}>
          <i className={`${clientTag.icon} mr-2`} style={{ color: clientTag.color }} />
          {clientTag.name}
        </span>
      ))}

      {resourceTags.map((resourceTag: Tag) => (
        <span className="mb-2" key={resourceTag._id} id={`tag_${resourceTag._id}`}>
          <i className={`${resourceTag.icon} mr-2`} style={{ color: resourceTag.color }} />
          {resourceTag.name}
        </span>
      ))}

      <div className="d-flex flex-wrap mb-2">
        {customTags.map((customTag: Tag) => {
          return (
            <span className="mr-2" key={customTag._id} id={`tag_${customTag._id}`}>
              <i className={`${customTag.icon} mr-2`} style={{ color: customTag.color }} />
              {customTag.name}
            </span>
          )
        })}
      </div>
    </div>
  )
}

export default ShiftTags
